import { Component } from "react";
import GeneralService from "./GeneralService";
import { Dict } from "styled-components/dist/types";
import { ChatCompletionRequest } from "../model_gen/chat";

export class RequestsService extends Component {
  public static getChatCompletionRerun(
    loadingHandler: any,
    payload: Dict,
    apiKey: string
  ) {
    return GeneralService.post(
      "/request/rerun",
      JSON.stringify(payload),
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static getRequestReruns(
    sessionId: string,
    applicationId: string,
    requestId: string,
    loadingHandler: any,
    apiKey: string
  ) {
    return GeneralService.get(
      `/session/reruns/${encodeURIComponent(
        sessionId
      )}/application/${applicationId}/request/${requestId}`,
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static getRequestMetadata(
    request: ChatCompletionRequest,
    loadingHandler: any,
    apiKey: string
  ) {
    return GeneralService.get(
      `/metadata/request/refs/${encodeURIComponent(
        request.application_ref_name
      )}/${request.action_type}/${request.request_id}`,
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static getApplicationActionRequests(
    applicationId: number,
    actionId: number,
    startDate: number,
    endDate: number,
    offset: number,
    limit: number,
    loadingHandler: any,
    apiKey: string
  ) {
    return GeneralService.get(
      `/application/${applicationId}/action/${actionId}/requests/${startDate}/${endDate}/${offset}/${limit}`,
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static getRequest(
    applicationId: string,
    applicationActionId: string,
    requestId: string,
    loadingHandler: any,
    apiKey: string
  ) {
    return GeneralService.get(
      `/request/${applicationId}/${applicationActionId}/${requestId}`,
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static getRequestById(
    requestId: string,
    loadingHandler: any,
    apiKey: string
  ) {
    return GeneralService.get(
      `/request/${requestId}`,
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

    public static getRequestResponseById(requestId: string, loadingHandler: any, apiKey: string) {
        return GeneralService.get(`/request/${requestId}/response`, loadingHandler, JSON, GeneralService.PROD_ENDPOINT, apiKey);
    }

    public static getRequestRepresentation(requestId: string, loadingHandler: any, apiKey: string) {
        return GeneralService.get(`/request/${requestId}/representation`, loadingHandler, JSON, GeneralService.PROD_ENDPOINT, apiKey);
    }


    public static updateRequestResponse(
        requestId: string,
        payload: any,
        loadingHandler: any,
        apiKey: string,
      ) {
        return GeneralService.put(
          `/request/${requestId}/response`,
          JSON.stringify(payload),
          loadingHandler,
          JSON,
          GeneralService.PROD_ENDPOINT,
          apiKey,
        );
      }
}
